import React from 'react';
import {BrowserRouter }
from "react-router-dom";
import { Footer } from './components/footer/Footer';
import {Headers} from "./components/header/Headers"
import { Main } from './components/main/NavigationsPages';

import "./stylesheets/css/main.css"

const App = () => (
  <BrowserRouter>
    <div className="app">
      <Headers />
      <Main />
      <Footer />
    </div>
  </BrowserRouter>
);

export default App